export default __webpack_public_path__ + "static/media/Logout.3500d7d0.svg";